import styles from "./NeedHelpLink.module.scss";

import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { ROUTES } from "@/modules/shared/consts/routes";

export const NeedHelpLink = ({
  mobileLink = false,
  to = ROUTES.support.embed.index,
}: {
  mobileLink?: boolean;
  to?: string;
}) => {
  const { t } = useTranslation();

  const className = mobileLink
    ? styles.mobileFooterLink
    : styles.desktopFooterLink;

  return (
    <Link to={to} className={className}>
      {t("bookingWidget.needHelpLink")}
    </Link>
  );
};
